var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSustainBuildingRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 318,
    viewBox: "0 0 372 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5766 162.946C145.14 83.5462 216.984 31.8028 307.096 7.71064C397.208 -16.3815 453.086 23.3206 474.721 126.807C496.356 230.299 491.629 324.201 460.541 408.519C429.453 492.836 368.537 542.736 277.791 558.223C187.045 573.709 119.932 531.55 76.4509 431.751C32.9702 331.947 38.0134 242.345 91.5766 162.946Z",
    fill: "#99CBC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_56152)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_190_56152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.66 533.913H277.643V209.262L332.66 204.621V533.913Z",
    fill: "#32988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.498 533.828L139.956 487.111V134.965L208.498 111.723V533.828Z",
    fill: "#32988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.663 521.151L374.347 521.112V235.83L332.663 204.607V521.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.498 533.82H285.014V169.537L208.498 111.714V533.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.418 555.163C238.5 559.393 260.202 562.105 290.237 559.768C371.731 544.828 425.017 488.09 448.471 447.714C481.212 391.348 484.036 323.652 484.896 300.037C485.033 296.141 484.68 397.439 414.262 466.05C385.766 493.816 348.886 508.051 311.244 507.621C296.39 507.444 280.012 505.741 266.507 500.552C192.317 472.023 169.587 411.185 162.179 323.208C161.574 315.982 161.222 279.562 161.222 279.562V75.8814C161.222 75.8814 73.2917 10.1679 73.2917 10.3637C73.2917 19.4297 73.2917 189.96 73.2917 290.508C73.2917 350.562 76.1844 388.686 99.9503 439.518C99.9503 439.518 131.417 518.527 227.418 555.144V555.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.547 550.261C325.547 550.261 140.148 610.702 78.33 369.621C71.9199 344.622 73.928 282.318 73.928 282.318V10.3634C73.928 10.2655 5.36658 73.0484 5.36658 73.2639C5.36658 83.2739 5.36658 216.891 5.36658 327.863C5.36658 330.586 5.40564 333.407 5.50336 336.267C9.93784 466.05 114.342 545.547 202.628 561.127C268.501 572.752 325.547 550.261 325.547 550.261Z",
    fill: "#32988F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_56152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484.889,
    height: 554.159,
    fill: "white",
    transform: "matrix(-1 0 0 1 484.889 10.334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_190_56152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484.889,
    height: 554.159,
    fill: "white",
    transform: "matrix(-1 0 0 1 491.187 10.3457)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainBuildingRight);
export default __webpack_public_path__ + "static/media/sustain_building_right.75fe95d3eb898f94096c49714e8400ba.svg";
export { ForwardRef as ReactComponent };